module.exports = __webpack_public_path__ + "img/项目管理.71a8630d.jpg";